import React, { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";
import { Field, Input } from "@/components/Field";

export default function Profile() {
  const { user, refreshUser } = useAuth();
  const { t, lang } = useI18n();
  const [f, setF] = useState({
    first_name: user?.first_name || "", last_name: user?.last_name || "", company: user?.company || "",
    phone: user?.phone || "", billing_address: user?.billing_address || "", vat_id: user?.vat_id || "",
  });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/auth/me", f); await refreshUser(); toast.success("OK"); }
    catch (err) { toast.error(apiErr(err)); }
  };
  const changePw = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/change-password", pw); toast.success("OK"); setPw({ current_password: "", new_password: "" }); }
    catch (err) { toast.error(apiErr(err)); }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <h1 className="font-display text-2xl font-black">{t("portal.profile")}</h1>
      <form onSubmit={save} className="surface p-6 space-y-4" data-testid="profile-form">
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label={t("auth.firstName")}><Input testid="p-first" value={f.first_name} onChange={set("first_name")} /></Field>
          <Field label={t("auth.lastName")}><Input testid="p-last" value={f.last_name} onChange={set("last_name")} /></Field>
        </div>
        <Field label={t("auth.company")}><Input testid="p-company" value={f.company} onChange={set("company")} /></Field>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label={t("auth.phone")}><Input testid="p-phone" value={f.phone} onChange={set("phone")} /></Field>
          <Field label="USt-IdNr."><Input testid="p-vat" value={f.vat_id} onChange={set("vat_id")} /></Field>
        </div>
        <Field label={lang === "de" ? "Rechnungsadresse" : "Billing address"}><Input testid="p-address" value={f.billing_address} onChange={set("billing_address")} /></Field>
        <button className="btn-primary" data-testid="profile-save">{t("common.save")}</button>
      </form>
      <form onSubmit={changePw} className="surface p-6 space-y-4" data-testid="password-form">
        <h2 className="font-display font-bold">{lang === "de" ? "Passwort ändern" : "Change password"}</h2>
        <Field label={lang === "de" ? "Aktuelles Passwort" : "Current password"}><Input testid="pw-current" type="password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} /></Field>
        <Field label={lang === "de" ? "Neues Passwort" : "New password"}><Input testid="pw-new" type="password" required minLength={6} value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} /></Field>
        <button className="btn-ghost" data-testid="pw-save">{t("common.save")}</button>
      </form>
    </div>
  );
}
